import service from './http'
/**
 *
 * @param {*} data
 */
// 密码登录
export function Login (data) {
  return service({
    url: '/customer/login',
    method: 'post',
    data: data
  })
}

// 获取个人资料
export function GetUserDetail() {
  return service({
    url: '/customer/findInfo',
    method: 'get',
    headers: {
      Authorization: localStorage.getItem('shangke_token')
    }
  })
}
// 获取省份
export function GetProvinceList() {
  return service({
    url: '/province/findList',
    method: 'get'
  })
}
// 获取市区
export function GetCityList(data) {
  return service({
    url: '/city/findList',
    method: 'get',
    params: data
  })
}
// 保存个人资料
export function SetUserDetail(data) {
  return service({
    url: '/customer/editPost',
    method: 'post',
    data: data,
    headers: {
      Authorization: localStorage.getItem('shangke_token')
    }
  })
}
// 上传头像
export function UploadImg(data) {
  return service({
    url: '/customer/updateAvatar',
    method: 'post',
    data: data,
    headers: {
      Authorization: localStorage.getItem('shangke_token'),
      'Content-Type': 'multipart/form-data'
    }
  })
}
